<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="RkmModal"
        title="Agenda do dia"
    >
        <rkm-alert show info>
            <strong>{{ dia }} - {{ getStringDiaSemana(semanaId) }}</strong>
        </rkm-alert>

        <rkm-table
            :fields="fields.tables.diaSelecionado"
            :items="items"
            hover
            striped
            sort-by="unidadeNome"
            responsive
        >
            <template v-slot:cell(vagasApp)="row">
                {{ row.item.vagasApp || '-' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="edit(item)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
        computed: {
        fields() {
            const columns = [
                { key: 'unidadeNome', label: 'Unidade', class: 'col-max', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', class: 'col-max', sortable: true },
                { key: 'prestadorNome', label: 'Prestador', class: 'col-max', sortable: true },
                { key: 'exameNome', label: 'Grupo de exame', class: 'col-max', sortable: true },
                { key: 'horaInicial', label: 'Inicio', class: 'col-max', sortable: true },
                { key: 'horaFim', label: 'Fim', class: 'col-max', sortable: true },
                { key: 'statusNome', label: 'Status', class: 'col-min', sortable: true },
                { key: 'vagas', label: 'Vagas', class: 'col-min', sortable: true },
            ]

            if (this.habilitaAgendamentoApp) {
                columns.push({ key: 'vagasApp', label: 'Vagas APP Cidadão', class: 'col-min', sortable: true })
            }

            columns.push(
                { key: 'tempoAtendimento', label: 'Tempo(min)', class: 'col-min', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min' }
            )

            return { tables: { diaSelecionado: columns } }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada')
        }
    },
    data: () => ({
        items: [],
        dia: null,
        semanaId: null,
    }),
    methods: {
        open(item, diaSelecionado, diaTratado, semanaId) {

            this.item = item           

            this.items = diaSelecionado

            this.dia = moment(diaTratado).format('DD/MM/YYYY')

            this.semanaId = semanaId

            this.$refs.RkmModal.show()
        },
        edit(item) {
            this.$emit('handleAlter', item)
            this.$refs.RkmModal.hide()
        },
        getStringDiaSemana(dia) {

            if(dia == '1'){
               return 'DOMINGO'

            } else if (dia == '2'){
               return 'SEGUNDA-FEIRA'

            } else if (dia == '3'){
               return 'TERÇA-FEIRA'

            } else if (dia == '4'){
               return 'QUARTA-FEIRA'

            } else if (dia == '5'){
               return 'QUINTA-FEIRA'

            } else if (dia == '6'){
               return 'SEXTA-FEIRA'

            } else if (dia == '7'){
               return 'SÁBADO'
            }
        },
    },
    props: {
        model: { type: Object, required: true },
        habilitaAgendamentoApp: { type: Boolean, default: false },
    },
    mixins: [ error, repository ],
}
</script>